<template>
    <div class="account" v-if="user">
        <main-container>
            <sep name="L"></sep>
            <account-teaser mode="account" :user="user" />
        </main-container>
        <sep name="L"></sep>
        <div class="background">
            <main-container>
                <sep name="L"></sep>
                <account-company :user="user" />
                <sep name="L"></sep>
                <account-info :user="user" />
                <sep name="L"></sep>
                <account-password v-if="user.canChangePassword" :user="user" />
                <sep name="L"></sep>
                <account-notification :user="user" />
            </main-container>
        </div>
    </div>
</template>

<script>
import AccountCompany from "./AccountCompany.vue";
import AccountInfo from "./AccountInfo.vue";
import AccountNotification from "./AccountNotification.vue";
import AccountPassword from "./AccountPassword.vue";
import AccountTeaser from "./AccountTeaser.vue";

export default {
    components: {
        AccountTeaser,
        AccountInfo,
        AccountPassword,
        AccountCompany,
        AccountNotification,
    },
    props: ["user"],
};
</script>

<style lang="sass" scoped>
.background
    background-color: $color-background
    padding-bottom: $grid-gutter * 2
</style>
